import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/components/Home'
import Index from '@/components/Index'
import About from '@/components/About'
import Products from '@/components/Products'
import ProductsDetail from '@/components/ProductsDetail'
import SolutionFTTx from '@/components/SolutionFTTx'
import SolutionDataCenter from '@/components/SolutionDataCenter'
import SolutionCustomized from '@/components/SolutionCustomized'
import News from '@/components/News'
import NewsDetail from '@/components/NewsDetail'
import CallUs from '@/components/CallUs'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Zhejiang Jiawei',
    component: Index,
    children: [{
      path: '/',
      component: Home,
      name: '',
      meta: { title: '浙江嘉威', titleEn: 'Zhejiang Jiawei', titleEs: 'Zhejiang Jiawei' },
    },
    {
      path: '/About',
      component: About,
      name: '',
      meta: { title: '关于我们', titleEn: 'About Us', titleEs: 'Sobre Nosotros' },
    },
    {
      path: '/Products',
      component: Products,
      name: '',
      meta: { title: '产品中心', titleEn: 'Products', titleEs: 'Productos' },
    },
    {
      path: '/ProductsDetail/:id',
      component: ProductsDetail,
      name: '',
      meta: { title: '产品详情', titleEn: 'Product Detail', titleEs: 'Detalle del Producto' },
    },
    {
      path: '/SolutionFTTx',
      component: SolutionFTTx,
      name: '',
      meta: { title: 'FTTx解决方案', titleEn: 'FTTx Solution', titleEs: 'Solución FTTx' },
    },
    {
      path: '/SolutionDataCenter',
      component: SolutionDataCenter,
      name: '',
      meta: { title: '数据中心解决方案', titleEn: 'Data Center Solution', titleEs: 'Solución de Centro de Datos' },
    },
    {
      path: '/SolutionCustomized',
      component: SolutionCustomized,
      name: '',
      meta: { title: '定制化服务', titleEn: 'Customized Service', titleEs: 'Servicio Personalizado' },
    },
    {
      path: '/News',
      component: News,
      name: '',
      meta: { title: '新闻资讯', titleEn: 'News', titleEs: 'Noticias' },
    },
    {
      path: '/NewsDetail/:id',
      component: NewsDetail,
      name: '',
      meta: { title: '新闻详情', titleEn: 'News Detail', titleEs: 'Detalle de Noticia' },
    },
    {
      path: '/CallUs',
      component: CallUs,
      name: '',
      meta: { title: '联系我们', titleEn: 'Contact Us', titleEs: 'Contacto' },
    },
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // About页面自行处理滚动（锚点定位）
    if (to.path === '/About') {
      return;
    }
    return { x: 0, y: 0 };
  }
})

export default router
